import Button from "../../../shared/components/Button";
import EventsAPI from "../../../shared/modules/EventsAPI";
import LoggedInHomePageHelper from "../modules/LoggedInHomePageHelper";
import ProductDescriptorsCarousel from "../../../shared/components/ProductDescriptorsCarousel";
import ProductPanel from "../../../shared/components/ProductPanel";
import PropTypes from "prop-types";
import React from "react";
import SharedPropTypes from "../modules/SharedPropTypes";
import VetoAPI from "../../Swap/modules/VetoAPI";
import {connect} from "react-redux";
import {fetchPDPrices} from "../../../actions/index";

class ShipmentInfo extends React.PureComponent {
  static propTypes = {
    "apiKey": PropTypes.string.isRequired,
    "customerId": PropTypes.string.isRequired,
    "fetchPDPrices": PropTypes.func.isRequired,
    "pdPrices": PropTypes.object.isRequired,
    "scenario": PropTypes.string.isRequired,
    "shipment": PropTypes.shape({
      "id": PropTypes.number.isRequired,
      "productDescriptors": SharedPropTypes.productDescriptors.isRequired,
      "timeDelivered": PropTypes.string,
      "timeLeft": PropTypes.number,
      "timeSent": PropTypes.string,
      "trackingNumber": PropTypes.string,
      "trackingUrl": PropTypes.string
    }).isRequired,
    "warehouseReducedCapacityText": PropTypes.string
  }

  static defaultProps = {"warehouseReducedCapacityText": ""}

  constructor (props) {
    super(props);
    this.state = {"expanded": false};

    const {shipment} = this.props;

    this.shipment = shipment;
    this.handlePeekClick = this.handlePeekClick.bind(this);
    this.finishVeto = this.finishVeto.bind(this);
    this.handleTrackMyBoxClick = this.handleTrackMyBoxClick.bind(this);
  }

  componentDidMount = () => {
    const {scenario} = this.props;
    if (scenario === "has_set" || scenario === "in_transit") {
      this.fetchCurrentSetPrices();
    }
  }

  fetchCurrentSetPrices = () => {
    const {
      fetchPDPrices, // eslint-disable-line no-shadow
      pdPrices,
      "shipment": {productDescriptors}
    } = this.props;
    const needPricePids = productDescriptors.
      map(productdesc => productdesc.id).
      filter(pid => !pdPrices || !pdPrices[pid]);
    if (needPricePids.length > 0) {
      fetchPDPrices(needPricePids, true);
    }
  }

  finishVeto = () => {
    const {apiKey, customerId, shipment} = this.props;
    VetoAPI.setApiToken(apiKey);
    VetoAPI.finishVeto(customerId, shipment.id, shipment.productDescriptors, shipment.productDescriptors.length).done(
      () => {
        window.location = "/";
      }
    );
  }


  handlePeekClick () {
    EventsAPI.trackCustomerEvent("clicked_cta_lihp", "Take a peek inside");
    this.setState(state => ({"expanded": !state.expanded}));
  }

  handleTrackMyBoxClick () {
    const {"shipment": {trackingUrl}} = this.props;
    EventsAPI.trackCustomerEvent("clicked_cta_lihp", "Track My Box");
    window.open(trackingUrl);
  }

  productPanels () {
    return (
      <div>
        <ProductDescriptorsCarousel productDescriptors={this.shipment.productDescriptors} />
        <div className="products-panel mb8">
          {this.shipment.productDescriptors.map(productDescriptor =>
            <ProductPanel
              key={`ShipmentInfo${productDescriptor.id}`}
              productDescriptor={productDescriptor}
            />)}
        </div>
      </div>
    );
  }

  inTransit () {
    const {expanded} = this.state;

    return (
      <div>
        <hr className="long-light-grey-line" />
        <div className="shipment-info mb24">
          <div className="mt16">
            <p className="styled_h6 inline align-left small">
              Shipped on:
            </p>
            <span className="inline align-right small">
              {this.shipment.timeSent}
            </span>
          </div>
          <div className="mt8">
            <p className="styled_h6 inline align-left small">
              Tracking #:
            </p>
            <a
              href={this.shipment.trackingUrl}
              target="_blank"
            >
              <span className="inline align-right small">
                {this.shipment.trackingNumber}
              </span>
            </a>
          </div>
        </div>
        <div className="center mb32 track-my-box-cta" >
          <a
            className="btn btn-primary centered fit"
            onClick={this.handleTrackMyBoxClick}
            target="_blank"
          >
            Track My Box
          </a>
        </div>
        <hr className="long-light-grey-line" />
        <div
          onClick={this.handlePeekClick}
        >
          <p className="styled_h6 left pt0 pb0 mt8 mb8 ml32 mr8 peek-inside">
            <img
              className="mr8"
              height="50px"
              src="https://karat-herokuapp-com.freetls.fastly.net/s3media/site/homepage/sneak-peek-box.png"
            />
            Take a peek inside
            <span
              className={expanded
                ? "glyphicon-minus peek-toggle"
                : "glyphicon-plus peek-toggle"}
            />
          </p>
        </div>

        <div>
          {expanded
            ? this.productPanels()
            : ""}
        </div>
      </div>

    );
  }

  hasSet () {
    return (
      <div>
        <hr className="long-light-grey-line" />
        <h2 className="mb0 pb0 center">
          Current Set
        </h2>
        {this.productPanels()}
        {LoggedInHomePageHelper.primaryAndSecondaryCta(
          [
            "Buy From My Set",
            "/account/feedback",
            "buy-from-my-set-cta"
          ], [
            "Leave Feedback",
            "/account/feedback",
            "leave-feedback-cta"
          ],
          "has-set"
        )}
      </div>
    );
  }

  preview () {
    const {warehouseReducedCapacityText} = this.props;

    return (
      <div>
        <hr className="long-light-grey-line" />
        <img
          className="mb8 mt8 center veto-timer mobile-only"
          height="54"
          src={`http://gen.sendtric.com/countdown/yoi8aahs27?to=${this.shipment.timeLeft}`} // eslint-disable-line
        />
        <hr className="long-light-grey-line mobile-only" />
        <img
          className="centered desktop-only pv48"
          height="329px"
          src="https://karat-herokuapp-com.freetls.fastly.net/s3media/site/homepage/GlitterBox-2024-desktop.png"
        />
        <img
          className="centered mobile-only mv32"
          height="120px"
          src="https://karat-herokuapp-com.freetls.fastly.net/s3media/site/homepage/GlitterBox-2024-mobile.png"
        />
        <img
          className="mb16 center veto-timer desktop-only"
          height="69"
          src={`http://gen.sendtric.com/countdown/yoi8aahs27?to=${this.shipment.timeLeft}`} // eslint-disable-line
        />
        <div className="center mb24 ps-btn">
          <a
            className="btn btn-primary sbs-btn"
            href="/account/preview_next_set"
            id="preview-next-set-cta"
          >
            Preview
          </a>
          <Button
            classes="btn-secondary sbs-btn no-thanks-surprise-me-cta"
            onClick={this.finishVeto}
            text="No thanks, surprise me"
          />
        </div>
        {
          warehouseReducedCapacityText &&
          <div className="center ph8 pt24 mb24 color-primary">
            {warehouseReducedCapacityText}
          </div>
        }
      </div>
    );
  }

  shipmentInfoContent (scenario) {
    switch (scenario) {
    case "in_transit":
      return this.inTransit(false);
    case "preview":
      return this.preview();
    case "has_set":
      return this.hasSet();
    default:
      return null;
    }
  }

  render () {
    const {scenario} = this.props;
    return (
      <div>
        {this.shipmentInfoContent(scenario)}
      </div>
    );
  }
}

const mapStoreToProps = store => ({"pdPrices": store.pdPrices || {}});

export default connect(mapStoreToProps, {fetchPDPrices})(ShipmentInfo);
